import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  isNonEmptyString,
  createCustomPropType,
  isUuid,
} from '../../../../js/app/react/validators';
import View from './BackView';
import {
  currentClientId,
  isBusySelector,
  isInSummaryEditSelector,
  isInSummarySelector,
  selectedGoalIdSelector,
} from '../../AdvWorkflow/AdvWorkflowSelector';
import {
  jumpBackInHistory,
  updateValidation,
  revert,
  pushIteratorToHistoryStack,
} from '../../AdvWorkflow/AdvWorkflowActions';
import { buildMutation } from '../../AdvWorkflow/AdvWorkflowHelpers';

const mapStateToProps = (state, ownProps) => ({
  clientId: currentClientId(state, ownProps),
  isBusy: isBusySelector(state, ownProps),
  hide: ownProps.hide || isInSummaryEditSelector(state, ownProps),
  browserBackInsteadOfWorkflowBack:
    isInSummarySelector(state, ownProps) && isUuid(selectedGoalIdSelector(state)),
});
const mapDispatchToProps = dispatch => ({
  onBack: (validationId, clientId, workflowId) => () => {
    if (validationId) {
      dispatch(updateValidation(buildMutation(validationId, []), workflowId, clientId));
    }
    dispatch(pushIteratorToHistoryStack(workflowId, clientId));
    dispatch(revert(workflowId, clientId));
    dispatch(jumpBackInHistory(workflowId));
  },
  onBrowserBack: () => {
    window.history.back();
  },
});

const BackContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(View);

BackContainer.defaultProps = {
  isFirstStep: false,
};

BackContainer.propTypes = {
  isFirstStep: PropTypes.bool,
  workflowId: createCustomPropType(isNonEmptyString).isRequired,
  validationId: createCustomPropType(isNonEmptyString).isRequired,
};

export default BackContainer;
